module.exports = __webpack_public_path__ + "static/media/bird.8f3c7ed8.svg";